interface CartItemImageProps {
  image: string;
  name: string;
}
export const CartItemImage = ({ image, name }: CartItemImageProps) => {
  return (
    <div className="relative w-20 h-20 bg-gray-50 rounded-lg overflow-hidden flex-shrink-0">
      <img
        src={image}
        alt={name}
        className="object-cover w-full h-full"
      />
    </div>
  );
};